import React from 'react';
import DashboardShell from '../components/DashboardShell';
import IgSchedulerApp from '../igscheduler/IgSchedulerApp';

/**
 * Instagram Reel/Post Scheduler -- ported from the standalone project at
 * src/igscheduler/ and frontend/src/igscheduler/ (see those folders' own
 * files for the original component tree). Mounted at /instagram-scheduler/*
 * in App.js behind ProtectedRoute (every logged-in role; see the
 * access-policy note in src/app.js). DashboardShell stays the outer RUSH REPUBLIC / Log out bar (no
 * Create account here, same as the other placeholder pages); the ported
 * tool's own UI -- unchanged from the standalone project, including its own
 * Sidebar/Header -- is its content.
 */
export default function InstagramScheduler() {
  return (
    <DashboardShell showCreateAccount={false}>
      <IgSchedulerApp />
    </DashboardShell>
  );
}
